import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-global-dashboard-skeleton',
  templateUrl: './global-dashboard-skeleton.component.html',
  styleUrls: ['./global-dashboard-skeleton.component.scss']
})
export class GlobalDashboardSkeletonComponent {
  // Propriété pour contrôler l'affichage du squelette des sites
  @Input() showSitesGrid: boolean = true;
}


